/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 水印状态管理 Slice（从 reducers/watermark.js 迁移）
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../app/store'
import actionTypes from '../constants/actionTypes'

// 水印类型定义（宽松类型，兼容页面中的 WM.Watermark 和 WM.OriginWatermark）
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Watermark = any

interface WatermarkState {
  watermarkList: Watermark[]
  draftWatermarkList: Watermark[]
}

const initialState: WatermarkState = {
  watermarkList: [],
  draftWatermarkList: []
}

const watermarkSlice = createSlice({
  name: 'watermark',
  initialState,
  reducers: {
    setWatermarks: (state, action: PayloadAction<Watermark[]>) => {
      state.watermarkList = action.payload
    },
    setDraftWatermarks: (state, action: PayloadAction<Watermark[]>) => {
      state.draftWatermarkList = action.payload
    },
    clearWatermarkEditor: () => initialState
  },
  extraReducers: (builder) => {
    // 监听旧 action 以保持兼容（watermarkEditor reducer 也会响应）
    builder.addCase(actionTypes.CLEAR_EDITOR, () => initialState)
  }
})

export const {
  setWatermarks,
  setDraftWatermarks,
  clearWatermarkEditor
} = watermarkSlice.actions

// Selectors
export const selectWatermarkList = (state: RootState) =>
  state.watermark.watermarkList
export const selectDraftWatermarkList = (state: RootState) =>
  state.watermark.draftWatermarkList

export default watermarkSlice.reducer
